import { createActions, createReducer } from "reduxsauce";

import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  adesaoSuccess: ["registros"],
  adesaoSuccessNotCleanError: ["registros"],
  adesaoFailure: ["error"],

  participanteRequest: [],
  participanteAtivoResposta: ["body", "toStep"],

  dadosCadastraisRequest: [],
  dadosCadastraisCepRequest: ["cep", "numero", "complemento"],

  dadosCadastraisRespFinanceiroRequest: [],
  dadosCadastraisRespFinanceiroCepRequest: ["cep"],

  parenteParticipanteRequest: [],

  parenteParticipanteAtivoResposta: ["body", "toStep"],

  importarDadosCadastraisRequest: ["body"],

  documentosRequest: [],

  salvarParticipante: ["registros"],

  inserirAdesaoRequest: ["body", "toStep"],
  atualizarAdesaoRequest: ["body", "toStep"],
  inserirBeneficiarioAdesaoRequest: ["body"],

  inserirDocumentoAdesaoRequest: ["body"],

  associadoEspecialRequest: [],

  solicitaAssinaturaRequest: ["body"],
  documentoAssinadoRequest: ["idDocumentoFornecedor"],
  parametrosConfirmacaoRequest: ["body"],

  verificaInscricaoInstituidorRequest: ["body"],
});

export const AdesaoTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  registros: {},
  loading: false,
  error: {},
});

export const reducer = createReducer(INITIAL_STATE, {
  [Types.ADESAO_SUCCESS_NOT_CLEAN_ERROR]: (state, { registros }) =>
    state.merge({
      registros: { ...state.registros, ...registros },
    }),
  [Types.ADESAO_SUCCESS]: (state, { registros }) =>
    state.merge({
      error: {},
      loading: false,
      registros: { ...state.registros, ...registros },
    }),
  [Types.SALVAR_PARTICIPANTE]: (state, { registros }) =>
    state.merge({
      registros: { ...state.registros, ...registros },
      error: {},
      loading: false,
    }),
  [Types.ADESAO_FAILURE]: (state, { error }) =>
    state.merge({ error, loading: false }),

  [Types.PARTICIPANTE_REQUEST]: (state) => state.merge({ loading: true }),

  [Types.PARTICIPANTE_ATIVO_RESPOSTA]: (state) =>
    state.merge({ loading: true }),

  [Types.DADOS_CADASTRAIS_REQUEST]: (state) => state.merge({ loading: true }),
  [Types.DADOS_CADASTRAIS_CEP_REQUEST]: (state) =>
    state.merge({ loading: true }),

  [Types.DADOS_CADASTRAIS_RESP_FINANCEIRO_REQUEST]: (state) =>
    state.merge({ loading: true }),
  [Types.DADOS_CADASTRAIS_RESP_FINANCEIRO_CEP_REQUEST]: (state) =>
    state.merge({ loading: true }),

  [Types.PARENTE_PARTICIPANTE_REQUEST]: (state) =>
    state.merge({ loading: true }),
  [Types.PARENTE_PARTICIPANTE_ATIVO_RESPOSTA]: (state) =>
    state.merge({ loading: true }),

  [Types.IMPORTAR_DADOS_CADASTRAIS_REQUEST]: (state) =>
    state.merge({ loading: true }),

  [Types.DOCUMENTOS_REQUEST]: (state) => state.merge({ loading: true }),

  [Types.INSERIR_ADESAO_REQUEST]: (state) => state.merge({ loading: true }),
  [Types.ATUALIZAR_ADESAO_REQUEST]: (state) => state.merge({ loading: true }),
  [Types.INSERIR_BENEFICIARIO_ADESAO_REQUEST]: (state) =>
    state.merge({ loading: true }),
  [Types.INSERIR_DOCUMENTO_ADESAO_REQUEST]: (state) =>
    state.merge({ loading: true }),

  [Types.ASSOCIADO_ESPECIAL_REQUEST]: (state) => state.merge({ loading: true }),

  [Types.SOLICITA_ASSINATURA_REQUEST]: (state) =>
    state.merge({ loading: true }),
  [Types.DOCUMENTO_ASSINADO_REQUEST]: (state) => state.merge({ loading: true }),
  [Types.PARAMETROS_CONFIRMACAO_REQUEST]: (state) =>
    state.merge({ loading: true }),
  [Types.VERIFICA_INSCRICAO_INSTITUIDOR_REQUEST]: (state) =>
    state.merge({ loading: true }),
});
